export const routePaths = Object.freeze({
  login: "/",
  welcome: "/welcome",
  changePassword: "/changepassword",
  userDetails: "/UserDetails",
  userAccessLog: "/UserAccessLog",
  iepfShare: "/IEPFShare",
  shHolding: "/ShHolding",
  exportReports: "/exportReports",
  companyEmployees: "/CompanyEmployees",
  corporateAction: "/CorporateAction",
  publicShareholding: "/PublicShareholding",
  NSDLCDSLCodes: "/NSDLCDSLCodes",
  companyDetails: "/CompanyDetails",
  shareholdersWithPan: "/ShareholdersWithPan",
  shareHoldingOverView: "/ShareHoldingOverView",
  companyAgmDetails: "/CompanyAgmDetails",
  agmAttendence: "/AgmAttendence",
  categoryUpdation: "/ShareholderInfo",
  bookClosureInfoForAll: "/BookClosureInfoForAll",
  Warning: "/warning",
  dividendDetails: "/DividendDetails",
  IEPFInfo: "/IEPFInfo",
  sellersBuyersDifference: "/SellersBuyersDiffrenceList",
  requestVerification: "/RequestVerification",
  shareholdingPatternWithPan: "/ShareholdingPatternWithPan",
  search: "/Search",
  transferBOHistory: "/TransferBOHistory",
  iEPFYearWiseReport: "/IEPFYearWiseReport",
  dividendInfo: "/DividendInfo",
  bouncedEmailList: "/BouncedEmailList",
  inwardDataVerification: "/InwardDataVerification",
  sebiScoresConsolidation: "/SebiScoresConsolidation",
  sebiFYReport: "/SebiFYReport",
  ReconciliationOverview: "/ReconcilationOverView",
  isinHistories: "/ISINHistories",
  findYourShareHolder: "/FindYourShareHolder",
  ShareholdingList: "/ShareHolderList",
  adminShareHoldingDetails: "/AdminShareHoldingDetails",
  quarterlysebiReport: "/QuarterlySebiReport",
  companyList: "/CompanyList",
  ReconciliationDetails: "/ReconciliationDetails",
  BoHistory: "/BOHistory",
  ShareholderDeclarationSearch: "/ShareholderDeclarationSearch",
  updateProcesss: "/UpdateProcess",
  shareholdingOfPromoters: "/ShareholdingOfPromoters",
  shareHolderPatternOld: "/ShareholdingPattern",
  CategoryWiseComparison: "/CategoryWiseComparison",
  Pas6: "/Pas6",
  distributionDetails: "/DistributionDetails",
  promoterAndGroupDisclosures: "/PromoterAndGroupDisclosures",
  promoterAndGroup: "/PromoterAndGroup",
  categoryWiseSH: "/Categorywiseshareholders",
  report: "/Sellers/BuyersList",
  pledgedShareholders: "/PledgedShareholders",
  stopTransfer: "/StopTransfer",
  transferDetails: "/TransferDetails",
  Iepf4report: "/IEPF4",
  mailingList: "/MailingList",
  remainderReport: "/RemainderReport",
  ROCFiling: "/CatageoryWiseFiles",
  deleteBenRecs: "/DeleteBenRecs",
  meaageTemplate: "/MessageTemplate",
  shareholdingPatternNew: "/ShareholdingPatternNew",
  masterUpdation: "/MasterUpdation",
  approvedReport : "/ApprovedReport",
   emailGeneral: "/EmailGeneral",
  queries: "/Queries",  
  dividendRemainder: "/DividendRemainder",
  InwardIntake: "/InwardIntake",
  emailTemplate: "/EmailTemplate",
  clientComunication: "/ClientComunication",
  dividendEmail: "/DividendEmail"
} as const);

/** When adding a path, register the screen in `src/app/routes/routeRegistry.tsx`. */

export type RoutePath = (typeof routePaths)[keyof typeof routePaths];
